export const enum ErrorMessages {
    IMAGE_UPLOAD_FAILED = 'UTILS.IMAGE_UPLOAD_FAILED'
}
